export const REGIMES = {
  OTHER_STATES: 'US_DNSS',
  VIRGINIA_USERS: 'va-users',
  CALIFORNIA_USERS: 'california-users',
} as const

export const REGIME_COPIES = {
  [REGIMES.OTHER_STATES]: {
    siteDependedVariable:
      'We use tracking technologies to personalize content, analyze performance, deliver ads and record site activity. We may share your data with third parties for marketing and advertising purposes. Request to <a href="https://www.shipt.com/privacy/intake-form">opt out</a> of “selling” or “sharing” of your data. Learn more in our <a href="https://www.shipt.com/legal/privacy-policy">Privacy Notice</a>',
  },
  [REGIMES.VIRGINIA_USERS]: {
    siteDependedVariable:
      "We use tracking technologies to personalize content, analyze performance, deliver ads, and record site activity. We may share your data with third parties for marketing and advertising purposes. You may <a href='https://www.shipt.com/privacy/intake-form'>opt out</a> of data “selling” or “sharing”. By continuing, you agree we may also process your consumer health data in accordance with Shipts Health Data Privacy Policy - See our <a href='https://www.shipt.com/legal/privacy-policy'>Privacy Notice</a> and <a href='https://www.shipt.com/legal/health-data-privacy-policy'>Health Data Privacy Policy</a> to learn more.",
  },
} as const
